import React, { Fragment, FunctionComponent, useEffect } from "react";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import { Theme, useTheme } from '@mui/material/styles';

import { ReactComponent as RawLogo } from "../assets/logo.svg";
import { flexbox } from '@mui/system';
import Wave from "react-wavify";
import PolarBear from "../components/lotties/PolarBear";
import {LanguagePicker} from "./LanguagePicker";

interface Props {
    language: string;
    toggleLanguage: (language: string | null) => void;
}

const pages = [''];
const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];
// const theme = useTheme();

export const NavBar: FunctionComponent<Props> = ({language, toggleLanguage}) => {
    
    const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
    const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
    const [theme, setTheme] = React.useState<Theme>(useTheme());

    const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    

    const HeaderLogo = () => <RawLogo height={50} width={100} />

    return (
        <AppBar position="static">
            <Container maxWidth="xl" sx={{ pt: 2 }}>
                <Toolbar disableGutters>
                    <Box sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} >
                        <Box sx={{ display: 'flex', flexDirection: "column", alignItems: "center", p: 1 }}>
                            <HeaderLogo />
                            <Typography
                                variant="caption"
                                noWrap
                                component="a"
                                href="/"
                                sx={{
                                    pt: 1,
                                    mr: 2,
                                    display: { xs: 'none', md: 'flex' },
                                    fontFamily: 'monospace',
                                    fontWeight: 700,
                                    letterSpacing: '.3rem',
                                    color: 'inherit',
                                    textDecoration: 'none',
                                }}
                            >
                                PT. ALSEN UTAMA MANDIRI
                            </Typography>
                        </Box>
                    </Box>

                    {/* hamburger menu, change xs to flex to enable in the future */}
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: { xs: 'block', md: 'none' },
                            }}
                        >
                            {pages.map((page) => (
                                <MenuItem key={page} onClick={handleCloseNavMenu}>
                                    <Typography textAlign="center">{page}</Typography>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                    <Container sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} >
                        <HeaderLogo />
                    </Container>
                    <Typography
                        variant="h5"
                        noWrap
                        component="a"
                        href=""
                        sx={{
                            mr: 2,
                            display: { xs: 'flex', md: 'none' },
                            flexGrow: 1,
                            fontFamily: 'monospace',
                            fontWeight: 700,
                            letterSpacing: '.3rem',
                            color: 'inherit',
                            textDecoration: 'none',
                        }}
                    >
                    </Typography>
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        {pages.map((page) => (
                            <Button
                                key={page}
                                onClick={handleCloseNavMenu}
                                sx={{ my: 2, color: 'white', display: 'block' }}
                            >
                                {page}
                            </Button>
                        ))}
                    </Box>

                    <Box sx={{ flexGrow: 0 }}>
                        <Tooltip title="Open settings">
                            <LanguagePicker
                                language={language}
                                toggleLanguage={toggleLanguage}
                            />
                        </Tooltip>
                        <Menu
                            sx={{ mt: '45px' }}
                            id="menu-appbar"
                            anchorEl={anchorElUser}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                        >
                            {settings.map((setting) => (
                                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                                    <Typography textAlign="center">{setting}</Typography>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                </Toolbar>
            </Container>
            <Wave fill={`${theme.palette.primary.main}`}
                paused={false}
                options={{
                    height: 5,
                    amplitude: 15,
                    speed: 0.12,
                    points: 5
                }}
                style={{
                    transform: "rotate(180deg) translateY(-15px)",
                    height: 15,
                    zIndex: 1000
                }}
            />
        </AppBar>
    );
};
